import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
    baseURL: API,
    timeout: 60000,
});

export const getProducts = async (category) => {
    const params = category ? { category } : {};
    const { data } = await apiClient.get("/products", { params });
    return data;
};

export const getCategories = async () => {
    const { data } = await apiClient.get("/categories");
    return data;
};

export const validateDiscount = async (code) => {
    const { data } = await apiClient.get("/discount/validate", { params: { code } });
    return data;
};

export const sendChat = async (sessionId, message) => {
    const { data } = await apiClient.post("/chat", {
        session_id: sessionId,
        message,
    });
    return data;
};

export const submitQuote = async (payload) => {
    const { data } = await apiClient.post("/quote", payload);
    return data;
};

export const saveQuoteDraft = async (payload) => {
    const { data } = await apiClient.post("/quote/draft", payload);
    return data;
};

export const downloadQuotePdfUrl = (quoteId) =>
    `${API}/quote/${quoteId}/pdf`;

export const subscribeNotifications = async (email) => {
    const { data } = await apiClient.post("/notifications/signup", {
        email,
        consent: true,
    });
    return data;
};
